import { createSlice } from '@reduxjs/toolkit'
import { SelectOption } from "../../shared/components/input";
import * as constant from '../../shared/util/constant';

interface lookupData {
    maritalStatusList: SelectOption[];
    industryList: SelectOption[];
    occupancyList: SelectOption[];
    relationshipList: SelectOption[];
    agencyList: SelectOption[];
    stateList : SelectOption[];
    claimsStatusList : SelectOption[];
    taskPriorityList : SelectOption[];
    taskStatusList : SelectOption[];
    lossTypeList : SelectOption[];
    activityTypeList : SelectOption[];
    employeeList : SelectOption[];
    companyList : SelectOption[];
    countryList: SelectOption[];
    stateUSList: SelectOption[];
    stateCanadaList: SelectOption[];
    genderList: SelectOption[];
    individualizedList: SelectOption[];
    policyTermStatusList: SelectOption[];
    policyTypeList: SelectOption[];
    policyBusinessTypeList: SelectOption[];
    policyPaymentPlanList: SelectOption[];
    attachTypeList: SelectOption[];
    transactionTypeList: SelectOption[];
    lineOfBusinessList: SelectOption[];
    sourceTypeList: SelectOption[];
    sourceTypeLookupValue: any;
    occupancyTypeList: SelectOption[];
    residenceTypeList: SelectOption[];
    constructionTypeList: SelectOption[];
    roofMaterialTypeList: SelectOption[];
    heatTypeList: SelectOption[];
    sprinklerTypeList: SelectOption[];
    dwellingConditionTypeList: SelectOption[];
    stormShutterTypeList: SelectOption[];
    dwellingLocTypeList: SelectOption[];
    secondaryHeatTypeList: SelectOption[];
    foundationTypeList: SelectOption[];
    cancellationReasonList: SelectOption[];
    deductibleTypes: SelectOption[];
    parentCompaniesList?: SelectOption[];
    writingCompaniesList?: SelectOption[];
    lobApplicationsList?: SelectOption[];
    formTypeList?: SelectOption[];
    runFrequencyTypeList?: SelectOption[];
    basementTypeList?: SelectOption[];
    numberOfFloorsTypeList?: SelectOption[];
    contentLocationTypeList?: SelectOption[];
    ratingTypeList?: SelectOption[];
    nearestShoreTypeList?: SelectOption[];
    elevatedFoundationTypeList?: SelectOption[];
    elevatedMaterialTypeList?: SelectOption[];
    enclosedForOtherPurposeTypeList?: SelectOption[];
    floodOccupancyTypeList?: SelectOption[];
    protectionDeviceTypeList?: SelectOption[];
    interestTypeList?: SelectOption[];
}

const intialLookupState: lookupData = {
    maritalStatusList: ([]),
    industryList: ([]),
    occupancyList: ([]),
    relationshipList: ([]),
    agencyList: ([]),
    stateList : ([]),
    claimsStatusList : ([]),
    lossTypeList : ([]),
    activityTypeList : ([]),
    taskStatusList : ([]),
    taskPriorityList : ([]),
    employeeList : ([]),
    companyList :([]),
    countryList: ([]),
    stateUSList: ([]),
    stateCanadaList: ([]),
    genderList: ([]),
    individualizedList: ([]),
    policyTermStatusList: ([]),
    policyTypeList: ([]),
    policyBusinessTypeList: ([]),
    policyPaymentPlanList: ([]),
    attachTypeList: [],
    transactionTypeList: ([]),
    lineOfBusinessList: ([]),
    sourceTypeList: ([]),
    sourceTypeLookupValue: (null),
    occupancyTypeList: ([]),
    residenceTypeList: ([]),
    constructionTypeList: ([]),
    roofMaterialTypeList: ([]),
    heatTypeList: ([]),
    sprinklerTypeList: ([]),
    dwellingConditionTypeList: ([]),
    stormShutterTypeList: ([]), 
    dwellingLocTypeList: ([]),
    secondaryHeatTypeList: ([]),
    foundationTypeList: ([]),
    cancellationReasonList: ([]),
    deductibleTypes: ([]),
    parentCompaniesList: ([]),
    writingCompaniesList: ([]),
    lobApplicationsList: ([]),
    formTypeList: ([]),
    runFrequencyTypeList: ([]),
    basementTypeList: ([]),
    numberOfFloorsTypeList: ([]),
    contentLocationTypeList: ([]),
    ratingTypeList: ([]),
    nearestShoreTypeList: ([]),
    elevatedFoundationTypeList: ([]),
    elevatedMaterialTypeList: ([]),
    enclosedForOtherPurposeTypeList: ([]),
    floodOccupancyTypeList: ([]),
    protectionDeviceTypeList: ([]),
    interestTypeList: ([]),
}



const LookupState = createSlice({
    name: "lookupState",
    initialState: intialLookupState,
    reducers: {
        updateLookupData(state, action) {
            switch (action.payload.type) {
                case constant.SlicerLookUpConstant.MARITAL_STATUS:
                    state.maritalStatusList = [...action.payload.data]
                    break;
                case constant.SlicerLookUpConstant.INDUSTRY:
                    state.industryList = [...action.payload.data]
                    break;
                case constant.SlicerLookUpConstant.OCCUPATION:
                    state.occupancyList = [...action.payload.data]
                    break;
                case constant.SlicerLookUpConstant.RELATIONSHIP:
                    state.relationshipList = [...action.payload.data]
                    break;
                case constant.SlicerLookUpConstant.AGENCY:
                    state.agencyList = [...action.payload.data]
                    break;
                case constant.SlicerLookUpConstant.STATE:
                    state.stateList = [...action.payload.data]
                    break;
                case constant.SlicerLookUpConstant.CLAIMS_STATUS:
                    state.claimsStatusList = [...action.payload.data]
                    break;
                case constant.SlicerLookUpConstant.LOSS_TYPE:
                    state.lossTypeList = [...action.payload.data]
                    break;
                case constant.SlicerLookUpConstant.ACTIVITY_TYPE:
                    state.activityTypeList = [...action.payload.data]
                    break;
                case constant.SlicerLookUpConstant.TASK_PRIORITY:
                    state.taskPriorityList = [...action.payload.data]
                    break;
                case constant.SlicerLookUpConstant.TASK_STATUS:
                    state.taskStatusList = [...action.payload.data]
                    break;
                case constant.SlicerLookUpConstant.EMPLOYEE_LIST:
                    state.employeeList = [...action.payload.data]
                    break;
                case constant.SlicerLookUpConstant.COMPANY_LIST:
                    state.companyList = [...action.payload.data]
                    break;
                case constant.SlicerLookUpConstant.COUNTRY:
                    state.countryList = [...action.payload.data]
                    break;
                case constant.SlicerLookUpConstant.US_STATE:
                    state.stateUSList = [...action.payload.data]
                    break;
                case constant.SlicerLookUpConstant.CANADA_STATE:
                    state.stateCanadaList = [...action.payload.data]
                    break;
                case constant.SlicerLookUpConstant.GENDER_STATE:
                    state.genderList = [...action.payload.data]
                    break;
                case constant.SlicerLookUpConstant.INDIVIDUALIZED:
                    state.individualizedList = [...action.payload.data];
                    break;
                case constant.SlicerLookUpConstant.POLICY_TERM_STATUS:
                    state.policyTermStatusList = [...action.payload.data];
                    break;
                case constant.SlicerLookUpConstant.POLICY_TYPE:
                    state.policyTypeList = [...action.payload.data];
                    break;
                case constant.SlicerLookUpConstant.POLICY_BUSINESS_TYPE:
                    state.policyBusinessTypeList = [...action.payload.data];
                    break;  
                case constant.SlicerLookUpConstant.POLICY_PAYMENT_PLAN:
                    state.policyPaymentPlanList = [...action.payload.data];
                    break;
                case constant.SlicerLookUpConstant.ATTACH_TYPE:
                    state.attachTypeList = [...action.payload.data];
                    break;
                 case constant.SlicerLookUpConstant.Transaction_Type:
                    state.transactionTypeList = [...action.payload.data];
                    break;
                case constant.SlicerLookUpConstant.Line_Of_Business:
                    state.lineOfBusinessList = [...action.payload.data];
                    break;  
                case constant.SlicerLookUpConstant.Source_Type:
                    state.sourceTypeList = [...action.payload.data];
                    break;
                 case constant.SlicerLookUpConstant.Source_Type_Lookup_Value:
                    state.sourceTypeLookupValue = {
                        ...state.sourceTypeLookupValue,
                        [action.payload.data.sourceTypeId]: action.payload.data.sourceTypeLookupValue,
                    };
                    break;
                case constant.SlicerLookUpConstant.OCCUPANCY_TYPE:
                    state.occupancyTypeList = [...action.payload.data];
                    break;
                case constant.SlicerLookUpConstant.RESIDENCE_TYPE:
                    state.residenceTypeList = [...action.payload.data];
                    break;
                case constant.SlicerLookUpConstant.CONSTRUCTION_TYPE:
                    state.constructionTypeList = [...action.payload.data];
                    break;
                case constant.SlicerLookUpConstant.ROOF_MATERIAL_TYPE:
                    state.roofMaterialTypeList = [...action.payload.data];
                    break;
                case constant.SlicerLookUpConstant.HEAT_TYPE:
                    state.heatTypeList = [...action.payload.data];
                    break;
                case constant.SlicerLookUpConstant.SPRINKLER_TYPE:
                    state.sprinklerTypeList = [...action.payload.data];
                    break;
                case constant.SlicerLookUpConstant.DWELLING_CONDITION_TYPE:
                    state.dwellingConditionTypeList = [...action.payload.data];
                    break;
                case constant.SlicerLookUpConstant.STORM_SHUTTER_TYPE:
                    state.stormShutterTypeList = [...action.payload.data];
                    break;
                case constant.SlicerLookUpConstant.DWELLING_LOC_TYPE:
                    state.dwellingLocTypeList = [...action.payload.data];
                    break;
                case constant.SlicerLookUpConstant.FLOOD_OCCUPANCY_TYPE:
                    state.floodOccupancyTypeList = [...action.payload.data];
                    break;
                case constant.SlicerLookUpConstant.PROTECTION_DEVICE_TYPE:
                    state.protectionDeviceTypeList = [...action.payload.data];
                    break;
                case constant.SlicerLookUpConstant.SECONDARY_HEAT_TYPE:
                    state.secondaryHeatTypeList = [...action.payload.data];
                    break;
                case constant.SlicerLookUpConstant.FOUNDATION_TYPE:
                    state.foundationTypeList = [...action.payload.data];
                    break;                
                case constant.SlicerLookUpConstant.Cancellation_Reason:
                    state.cancellationReasonList = [...action.payload.data];
                break;
                case constant.SlicerLookUpConstant.DEDUCTIBLE_TYPES:
                    state.deductibleTypes = [...action.payload.data];
                break;
                case constant.SlicerLookUpConstant.PARENT_COMPANIES:
                    state.parentCompaniesList = [...action.payload.data];
                break;
                case constant.SlicerLookUpConstant.WRITING_COMPANIES:
                    state.writingCompaniesList = [...action.payload.data];
                break;
                case constant.SlicerLookUpConstant.LOB_APPLICATIONS:
                    state.lobApplicationsList = [...action.payload.data];
                break;
                case constant.SlicerLookUpConstant.FORM_TYPE:
                    state.formTypeList = [...action.payload.data];
                break;
                case constant.SlicerLookUpConstant.RUN_FREQUENCY_TYPE:
                    state.runFrequencyTypeList = [...action.payload.data];
                break;
                case constant.SlicerLookUpConstant.BASEMENT_TYPE:
                    state.basementTypeList = [...action.payload.data];
                break;
                case constant.SlicerLookUpConstant.NUMBER_OF_FLOORS_TYPE:
                    state.numberOfFloorsTypeList = [...action.payload.data];
                break;
                case constant.SlicerLookUpConstant.CONTENT_LOCATION_TYPE:
                    state.contentLocationTypeList = [...action.payload.data];
                break;
                case constant.SlicerLookUpConstant.RATING_TYPE:
                    state.ratingTypeList = [...action.payload.data];
                break;
                case constant.SlicerLookUpConstant.NEAREST_SHORE_TYPE:
                    state.nearestShoreTypeList = [...action.payload.data];
                break;
                case constant.SlicerLookUpConstant.ELEVATED_FOUNDATION_TYPE:
                    state.elevatedFoundationTypeList = [...action.payload.data];
                break;
                case constant.SlicerLookUpConstant.ELEVATED_MATERIAL_TYPE:
                    state.elevatedMaterialTypeList = [...action.payload.data];
                break;
                case constant.SlicerLookUpConstant.ENCLOSED_FOR_OTHER_PURPOSE_TYPE:
                    state.enclosedForOtherPurposeTypeList = [...action.payload.data];
                break;
                case constant.SlicerLookUpConstant.INTEREST_TYPE:
                    state.interestTypeList = [...action.payload.data];
                break;
                default:
                    break;
            }
        }
    }
})
export const { updateLookupData } = LookupState.actions
export default LookupState.reducer;

